<!--
 * @Author: Latte
 * @Date: 2022-02-10 14:12:50
 * @LAstEditors: Latte
 * @LastEditTime: 2022-02-25 10:49:49
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\module-management\filterSetting\index.vue
-->
<template>
	<el-card class="box-card">
		<el-form :model="row" class="form-container">
			<el-form-item label="栏目名称" prop="columnName">
				<el-input v-model="row.columnName" style="width: 60%" size="small" disabled></el-input>
			</el-form-item>
			<!-- <el-form-item label="筛选功能" prop="isEnable">
        <el-switch
          v-model="row.isEnable"
          active-text="启用"
          inactive-text="禁用"
        >
        </el-switch>
      </el-form-item> -->
	  
			<el-form-item label="筛选条件" prop="conditionsList" >
				<el-button size="mini" @click.stop="addCondition()">新增条件</el-button>
				<el-table :data="conditionForm.conditionsList" border style="margin-top: 20px;height: 60vh;overflow: auto;;">
					<el-table-column label="ID" prop="maiColumnConditionID" align="center"></el-table-column>
					<el-table-column label="排序值" prop="sort" align="center"></el-table-column>
					<el-table-column label="条件名称" prop="showName" align="center"></el-table-column>
					<el-table-column label="类型" prop="type" align="center">
						<template slot-scope="scope">
							{{ scope.row.type === 0 ? "筛选" : "排序" }}
						</template>
					</el-table-column>
					<el-table-column label="fieldName" prop="fieldName" align="center"></el-table-column>
					<el-table-column label="状态" prop="isEnable" align="center" width="150">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.isEnable" active-text="启用" inactive-text="禁用"
								@change="handleChangeStatus($event, scope.row)">
							</el-switch>
						</template>
					</el-table-column>
					<el-table-column label="值" prop="value" align="center">
						<template slot-scope="scope">
							{{ formatConditionValue(scope.row.childConditionList) }}
							<i @click="openChildConditionListDlg(scope.row)" class="el-icon-setting"
								style="float: right;font-size: 23px; "></i>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" width="200">
						<template slot-scope="scope">
							<el-button type="primary" size="small" @click.stop="handleUpdateCondition(scope.row)">编辑
							</el-button>
							<el-button type="danger" size="small" @click.stop="handleRemove(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="small">保 存</el-button>
				<el-button size="small" @click.stop="$router.go(-1)">返 回</el-button>
			</el-form-item>
		</el-form>

		<!-- 子条件列表 -->
		<el-dialog title="子条件列表" :visible.sync="childConditionListVisiable" :close-on-click-modal="false">
			<el-button @click="openAddChildConditionDlg()">添加子条件</el-button>
			<div style="height: 60vh;overflow: auto;">
				<el-table :data="childConditionList" border style="margin-top: 20px">
					<el-table-column label="排序值" prop="sort" align="center"></el-table-column>
					<el-table-column label="条件名称" prop="showName" align="center"></el-table-column>
					<el-table-column label="类型" prop="type" align="center">
						<template slot-scope="scope">
							{{ scope.row.type === 0 ? "筛选" : "排序" }}
						</template>
					</el-table-column>
					<el-table-column label="fieldName" prop="fieldName" align="center"></el-table-column>
					<el-table-column label="状态" prop="isEnable" align="center" width="150">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.isEnable" active-text="启用" inactive-text="禁用"
								@change="handleChangeStatus($event, scope.row)">
							</el-switch>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" width="200">
						<template slot-scope="scope">
							<el-button type="primary" size="small" @click.stop="handleUpdateCondition(scope.row)">编辑
							</el-button>
							<el-button type="danger" size="small" @click.stop="handleRemove(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>

		</el-dialog>

		<!-- 添加条件 -->
		<el-dialog title="添加条件" :visible.sync="conditionDialogVisible" :close-on-click-modal="false">
			<el-form ref="addFormRef" :model="addConditionForm">
				<el-form-item label="条件名称" prop="showName" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
					<el-input v-model="addConditionForm.showName"></el-input>
				</el-form-item>
				<el-form-item label="条件名称（俄语版）" prop="label">
					<el-input v-model="addConditionForm.showNameRussian"></el-input>
				</el-form-item>
				<el-form-item label="是否启用" prop="isEnable">
					<el-radio v-model="addConditionForm.isEnable" :label="true">是</el-radio>
					<el-radio v-model="addConditionForm.isEnable" :label="false">否</el-radio>
				</el-form-item>
				<el-form-item label="类型" prop="type">
					<el-radio v-model="addConditionForm.type" :label="0">筛选</el-radio>
					<el-radio v-model="addConditionForm.type" :label="1">排序</el-radio>
				</el-form-item>

				<el-form-item label="排序" prop="sort" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
					<el-input-number v-model="addConditionForm.sort" :min="1"></el-input-number>
				</el-form-item>
				<el-form-item label="条件字段名( fieldName )" prop="fieldName" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
					<el-input v-model="addConditionForm.fieldName"></el-input>
				</el-form-item>
				<el-form-item v-if="addConditionForm.type == 1" label="op" prop="type">
					<el-input v-model="addConditionForm.fieldOp"></el-input>
				</el-form-item>
				<!-- 
				<el-form-item label="筛选值：用逗号“，”隔开。比如：腹部，泌尿，其他">
					<el-input v-model="addConditionForm.fieldValue"></el-input>
				</el-form-item> -->
			</el-form>
			<div slot="footer">
				<el-button size="small" @click="conditionDialogVisible = false "> 取消 </el-button>
				<el-button type="primary" size="small" @click.stop="confirmAddCondition()">
					确认
				</el-button>
			</div>
		</el-dialog>

		<!-- 编辑条件 -->
		<el-dialog title="编辑模块" :visible.sync="updateConditionDialogVisible" width="60%" :close-on-click-modal="false">
			<el-form :model="updateConditionForm">
				<el-form-item label="名称" prop="showName">
					<el-input v-model="updateConditionForm.showName"></el-input>
				</el-form-item>
				<el-form-item label="名称(俄语版)" prop="showNameRussian">
					<el-input v-model="updateConditionForm.showNameRussian"></el-input>
				</el-form-item>
				<el-form-item label="排序" prop="sort">
					<el-input-number :min="1" v-model="updateConditionForm.sort"></el-input-number>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="updateConditionDialogVisible = false">取 消</el-button>
				<el-button type="primary" size="small" @click="updateData">确 定</el-button>
			</div>
		</el-dialog>
	</el-card>
</template>

<script>
	import {
		addColumnCondition,
		getColumnCondition,
		updateColumnCondition,
		deleteColumnCondition,
	} from "@/api/system/columnManagement/index";
	import {
		printObj
	} from "@/utils/debug"
	export default {
		props: {
			row: {
				type: Object,
				require: true,
			},
		},

		data() {
			return {
				conditionForm: {
					name: "",
					conditionsList: [],
				},
				// 新增条件对话框的开关
				conditionDialogVisible: false,
				addConditionForm: {},
				// 筛选值列表
				conditionValue: "",
				// 编辑条件对话框的开关
				updateConditionDialogVisible: false,
				updateConditionForm: {},
				dlgType: "", //新增、修改是针对条件还是子条件
				conditionEntity: {},
				//子条件相关
				childConditionListVisiable: false,
				childConditionList: {},


			};
		},

		computed: {
			formatConditionValue() {
				return function(list) {
					const showNameList = list.map((item) => {
						return item.showName;
					});

					return showNameList.join("，");
				};
			},
		},

		created() {
			console.log(this.row);
			this.getColumnCondition();
		},

		methods: {
			openChildConditionListDlg(entity) {
				this.childConditionList = entity.childConditionList
				this.conditionEntity = entity
				this.childConditionListVisiable = true
			},
			openAddChildConditionDlg() {
				this.dlgType = 'childCondition'
				this.resetChildConditionForm()
				this.conditionDialogVisible = true
				this.$refs.addFormRef.clearValidate()
			},
			// 获取栏目条件
			async getColumnCondition() {
				const params = {
					lang: 0, // 语言0-英文，1-俄语（海外版起作用）
					maiColumnID: this.row.maiColumnID,
				};

				const res = await getColumnCondition(params);

				console.log(res);
				this.conditionForm.conditionsList = res.data;
			},
			/**
			 * 控制栏目条件状态
			 * @param {*} status
			 * @param {*} row
			 */
			async handleChangeStatus(status, row) {
				const params = {
					maiColumnConditionID: row.maiColumnConditionID,
					isEnable: status,
					showName: row.showName
				};

				const res = await updateColumnCondition(params);

				if (res.code === 200) {
					this.$message.success("操作成功");
				} else {
					this.$message.error("操作失败");
				}
			},
			// 添加筛选条件
			addCondition() {
				this.dlgType = 'condition'
				this.resetForm();
				this.conditionDialogVisible = true;
				this.$refs.addFormRef.clearValidate()
			},
			/**
			 * 删除栏目条件
			 */
			async handleRemove(row) {
				this.conditionEntity = row
				this.$confirm("此操作将永久删除该模块条件, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						return {
							id: row.maiColumnConditionID
						};
					})
					.then((res) => {
						return deleteColumnCondition(res);
					})
					.then((res) => {
						
						if (res.code === 200) {
							this.$message.success("删除成功");
							if(this.conditionEntity.level === 1){//子条件删除，
								for(var i = 0;i< this.childConditionList.length;i++){
									let temp = this.childConditionList[i]
									if(temp.maiColumnConditionID === this.conditionEntity.maiColumnConditionID){
										this.childConditionList.splice(i, 1); 
										break
									}
								}
							}else{
								this.getColumnCondition();
							}
							
						} else {
							this.$message.error("删除失败");
							this.getColumnCondition();
						}
					})
					.catch((error) => {
						console.log("error", error);
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			/**
			 * 重置创建数据
			 */
			resetForm() {
				this.addConditionForm = {
					showName: "",
					showNameRussian: "",
					type: 0,
					parentID: 0,
					maiColumnID: this.row.maiColumnID,
					level: 0, // 级别 0-一级条件，1-二级条件
					isEnable: true,
					fieldValue: "",
					fieldOp: "equal",
					fieldName: "",
				};
			},
			resetChildConditionForm() {
				this.addConditionForm = {
					showName: "",
					showNameRussian: "",
					type: 0,
					parentID: this.conditionEntity.maiColumnConditionID,
					maiColumnID: this.row.maiColumnID,
					level: 1, // 级别 0-一级条件，1-二级条件
					isEnable: true,
					fieldValue: "",
					fieldOp: "equal",
					fieldName: "",
				};
			},
			/**
			 * 确认创建条件
			 */
			async confirmAddCondition() {
				// const conditionValueList = this.conditionValueList.split("，");
				// this.addConditionForm.childConditionList = conditionValueList.map(
				//   (item, index) => {
				//     const condition = {
				//       type: 0,
				//       sort: index + 1,
				//       showName: item,
				//       parentID,
				//       maiColumnID: this.row.maiColumnID,
				//       level: 1, // 级别 0-一级条件，1-二级条件
				//       isEnable: true,
				//       fieldValue: String(index + 1),
				//       fieldOp: "equal",
				//       fieldName: this.addConditionForm.fieldName,
				//     };
				//   }
				// );
				
				let validate = await this.$refs.addFormRef.validate()
				if(!validate){
					return
				}
				
				const data = {
					...this.addConditionForm
				};
				const res = await addColumnCondition(data);

				if (res.code === 200) {
					this.$message.success("操作成功");
					this.conditionDialogVisible = false;
					if(this.dlgType === 'childCondition'){//子条件添加
						this.conditionEntity.childConditionList.push(res.data)
					}else{
						this.getColumnCondition();
					}
					
				} else {
					this.$message.error("操作失败");
					this.conditionDialogVisible = false;
					this.getColumnCondition();
				}
			},
			/**
			 * 打开编辑条件的对话框
			 */
			handleUpdateCondition(entity) {
				//记录修改对象，更新成功后修改对应属性值
				this.conditionEntity = entity
				this.updateConditionForm = {
					...entity
				};
				this.updateConditionDialogVisible = true;
			},
			/**
			 * 更新条件
			 */
			async updateData() {
				const params = Object.assign({}, this.updateConditionForm);

				try {
					const res = await updateColumnCondition(params);
					if (res.code === 200) {
						Object.assign(this.conditionEntity, params)
						this.$message.success("操作成功");
					} else {
						this.$message.error("操作失败");
					}
					this.updateConditionForm = {};
					this.updateConditionDialogVisible = false;
				} catch (error) {
					console.log(error);
				}
			},
		},
	};
</script>


<style scoped>
</style>
